export const ADD_COMPARE_HOUSE = 'ADD_COMPARE_HOUSE';
export const EMPTY_COMPARE_HOUSES = 'EMPTY_COMPARE_HOUSES';
export const HOME_MAP_BOUND_CHANGED = 'HOME_MAP_BOUND_CHANGED';
export const HOME_DISPLAY_HOUSES_CHANGED = 'HOME_DISPLAY_HOUSES_CHANGED';
export const HOME_MAP_FOCUSED_MARKER_CHANGED = 'HOME_MAP_FOCUSED_MARKER_CHANGED';
export const SEARCH_HOUSES_RESULT_CHANGED = 'SEARCH_HOUSES_RESULT_CHANGED';
export const SEARCH_MAP_FOCUSED_MARKER_CHANGED = 'SEARCH_MAP_FOCUSED_MARKER_CHANGED';
export const SEARCH_CONDITION_CHANGED = 'SEARCH_CONDITION_CHANGED';
export const SELL_DIALOG_TOGGLED = 'SELL_DIALOG_TOGGLED';
export const HOUSE_UPDATE_DIALOG_TOGGLED = 'HOUSE_UPDATE_DIALOG_TOGGLED';
export const USER_UPDATE_DIALOG_TOGGLED = 'USER_UPDATE_DIALOG_TOGGLED';
export const SEARCH_MAP_HOVERED_MARKER_CHANGED = 'SEARCH_MAP_HOVERED_MARKER_CHANGED';


// WEBPACK FOOTER //
// ./src/redux/constants/action-types.js